import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import { QUERY_KEYS } from "./querykeys";
import ApiRequest from "../ApiRequest";
import { requestURLs } from "@/Environment";
import { useQuery } from "@tanstack/react-query";
import {
  BillingCycleSchema,
  LanguageEnumSchema,
  PlanTypeEnumSchema,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { OrganisationType, severity } from "../mutation/useOrganisationMutation";
import { UserAvailability } from "./useOrganisationDetailsQuery";

export type UserType = {
  customerId: string | null;
  userId: string;
  email: string;
  status: string;
  firstName: string | null;
  lastName: string | null;
  timezone: string | null;
  country: string | null;
  avatarImg: string | null;
  isVerified: boolean;
  createdAt: string;
  updatedAt: string;
  userAvailability: UserAvailability[];
  userOrganisation: UserOrganisationType[];
  provider?: Provider[];
  deletedAt?: string;
  language: keyof typeof LanguageEnumSchema;
  subscription: SubscriptionType | undefined;
  severityTypes:severity[]
  isTutorialShow?:boolean
  managedPortfolioIds?: string[];
  managedProgramIds?: string[];
  managedProjectIds?: string[];
};
export interface SubscriptionType {
  subScriptionId:       string;
  userId:               string;
  customerId:           string;
  stripeSubscriptionId: string;
  planType:             keyof typeof PlanTypeEnumSchema | null;
  billingCycle:         keyof typeof BillingCycleSchema;
  isActive:             boolean;
  startDate:            Date;
  endDate:              null;
  createdAt:            Date;
  updatedAt:            Date;
  downgradeRequestAt:   Date | null;
  downgradeDetails?:      string
}


export type UserOrganisationType = {
  userOrganisationId: string;
  userId: string;
  organisationId: string;
  role: keyof typeof UserRoleEnumValue | null;
  jobTitle: null;
  taskColour: null;
  createdAt: Date;
  updatedAt: Date;
  holidayCsvUrl?: string | null;
  organisation: OrganisationType;
  riskType?:string[]|null
  timesheetMgmtAnnouncementDismissedAt?: string | null;
};

export interface Provider {
  providerType?: string;
  FreeTrialCreatedAt: string | null;
}

export type UserResponseType = ResponseType<UserType>;

function useCurrentUserQuery() {
  return useQuery<
    AxiosResponseAndError<UserResponseType>["response"],
    AxiosResponseAndError<UserResponseType>["error"]
  >({
    queryKey: [QUERY_KEYS.currentUser],
    queryFn: async () => ApiRequest.get(requestURLs.me),
    enabled: false,
    retry: 0,
  });
}

export default useCurrentUserQuery;
